import {
    Component,
    ElementRef,
    Inject,
    OnInit,
    ViewChild,
} from "@angular/core";
import {
    FormBuilder,
    FormControl,
    FormGroup,
    Validators,
} from "@angular/forms";
import {
    MAT_DIALOG_DATA,
    MatDialog,
    MatDialogRef,
} from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";

import { AccountSettingService } from "src/app/Services/account-setting.service";
import { LoginUsersService } from "src/app/Services/login-users.service";
import { StaticPagesService } from "src/app/Services/static-pages.service";

import { TranslateService } from "@ngx-translate/core";

import { CheckoutService } from "../../../Services/checkout.service";
import { EmbryoService } from "../../../Services/Embryo.service";
import { CheckoutAcceptDialog } from "../checkout-accept-dialog/checkout-accept-dialog.component";
import { IframeModalComponent } from "../iframe-modal/iframe-modal.component";
import * as $ from "jquery";
@Component({
    selector: "app-add-edit-phone-and-verify",
    templateUrl: "./add-edit-phone-and-verify.component.html",
    styleUrls: ["./add-edit-phone-and-verify.component.css"],
})
export class AddEditPhoneAndVerifyComponent implements OnInit {
    verifyForm!: FormGroup;
    lang: any;
    phoneForm!: FormGroup;
    phoneSuccessflly: boolean = false;
    user: any;
    toggleLoading: boolean = false;
    isGuest: boolean = false;
    environmentVariables: any;
    interval: any;
    verifyLoading: boolean = false;
    showInputErrorEnterCode: boolean = false;
    updatePhoneLoading: boolean = false;
    public intialNumber = 1;
    @ViewChild("verifyCodeInput", { static: false })
    verifyCodeInput!: ElementRef;

    constructor(
        private formBuilder: FormBuilder,
        private accountService: AccountSettingService,
        private auth: LoginUsersService,
        public dialog: MatDialog,
        public dialogRef: MatDialogRef<AddEditPhoneAndVerifyComponent>,
        public snackBar: MatSnackBar,
        private checkoutService: CheckoutService,
        private translate: TranslateService,
        private embryoService: EmbryoService,
        public router: Router,
        private confgServ: StaticPagesService,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {
        embryoService.emitLang.subscribe((lang: string) => {
            translate.setDefaultLang(lang);
            this.lang = lang;
        });
        // if(this.data.promo.promo){
        //   const promo =  this.data.promo;
        //   delete this.data.promo;
        //   this.data.promo = promo.promo
        // }
    }

    onBlur(e: any) {
        if (this.intialNumber == e) {
            this.verifyCodeInput.nativeElement.focus();
            this.intialNumber += 1;
        } else {
            $(document).off("blur", "#verifyCodeId");
            this.showInputErrorEnterCode = true;
        }
    }

    ngOnInit() {
        this.isGuest = this.auth.isGuest();
        // const numberReg = '^01[0-9]\\d*(\\.\\d{1,2})?$';
        this.lang = localStorage.getItem("lang");
        this.translate.setDefaultLang(this.lang);

        if (this.data.phone) {
            this.phoneSuccessflly = false;
        } else {
            this.phoneSuccessflly = true;
            this.user = this.auth.getUser();
        }
        if (this.data.editPhone) {
            this.editPhone();
        }
        this.lang = localStorage.getItem("lang");
        this.verifyForm = new FormGroup({
            code: new FormControl("", Validators.required),
        });
        this.phoneForm = new FormGroup({
            phone: new FormControl(this.user ? this.user.phone : "", [
                Validators.required,
                // Validators.pattern(numberReg),
            ]),
        });
        this.confgServ.getenvConfig().subscribe((res) => {
            this.environmentVariables = res;
            if (this.environmentVariables?.localization) {
                this.phoneForm.controls.phone.setValidators([
                    Validators.required,
                    Validators.minLength(
                        this.environmentVariables?.localization?.phone_length <
                            1000
                            ? this.environmentVariables?.localization
                                  ?.phone_length
                            : 0
                    ),
                    Validators.maxLength(
                        this.environmentVariables?.localization?.phone_length
                    ),
                    Validators.pattern(
                        this.environmentVariables?.localization?.phone_pattern
                    ),
                ]);
            } else {
                this.interval = setInterval(() => {
                    if (this.environmentVariables?.localization) {
                        this.phoneForm.controls.phone.setValidators([
                            Validators.required,
                            Validators.minLength(
                                this.environmentVariables?.localization
                                    ?.phone_length < 1000
                                    ? this.environmentVariables?.localization
                                          ?.phone_length
                                    : 0
                            ),
                            Validators.maxLength(
                                this.environmentVariables?.localization
                                    ?.phone_length
                            ),
                            Validators.pattern(
                                this.environmentVariables?.localization
                                    ?.phone_pattern
                            ),
                        ]);
                        clearInterval(this.interval);
                        this.phoneForm.controls.phone.updateValueAndValidity();
                    }
                }, 1000);
            }
            this.phoneForm.controls.phone.updateValueAndValidity();
        });
    }

    submitPhone() {
        if (this.phoneForm.valid) {
            let message = "";
            let edit_message = "";
            this.lang == "en"
                ? ((message = "Phone Added Successfully"),
                  (edit_message = "Phone Updated Successfully"))
                : ((message = "تم تسجيل الرقم"),
                  (edit_message = "تم تعديل الرقم بنجاح"));

            let data = this.phoneForm.value;
            data.device_type = 1;
            console.log(this.router.url);
            if(this.router.url.includes('profile')){
                data.send_otp = false;
            }else{
                data.send_otp = true;
            }
            this.updatePhoneLoading = true;
            this.checkoutService.editPhone(data).subscribe((response: any) => {
                this.updatePhoneLoading = false;
                if (response.code === 200) {
                    this.auth.setToken(response.data.token);
                    this.auth.setUserDataEmit(response.data);
                    if (this.data.noPromo) {
                        this.dialogRef.close(response);
                    }
                    this.snackBar.open(
                        this.user?.phone ? edit_message : message,
                        "×",
                        {
                            panelClass: "success",
                            verticalPosition: "top",
                            duration: 3000,
                        }
                    );

                    this.auth.setUser(response.data);

                    this.user = response.data;

                    this.phoneSuccessflly = true;
                    if (
                        !this.environmentVariables.SMS_CONNECTION ||
                        this.data.profilePhone
                    ) {
                        this.user.phone_verified = 1;
                        localStorage.setItem(
                            "auth_user_crocs",
                            JSON.stringify(this.user)
                        );
                        if (!this.data.no_emit) {
                            this.auth.userEmit.emit(this.user);
                        }

                        this.dialogRef.close(response);
                    }
                    if (
                        response.data &&
                        !response.data?.is_guest &&
                        !response.data?.phone_verified &&
                        this.environmentVariables?.VERIFY_AFTER_SIGNUP &&
                        !this.router.url.includes("verify-phone")
                    ) {
                        this.router.navigate([
                            "/" + this.lang + "/verify-phone/",
                        ]);
                    }
                } else {
                    this.snackBar.open(response.message, "×", {
                        panelClass: "error",
                        verticalPosition: "top",
                        duration: 3000,
                    });
                }
            });
        } else {
            this.verifyForm.get("code")?.markAsTouched();
            this.markFormGroupTouched(this.verifyForm);
            this.markFormGroupTouched(this.phoneForm);
            return;
        }
    }

    submitCode() {
        if (this.verifyForm.valid) {
            this.data.verification_code = this.verifyForm.get("code")?.value;
            this.data.device_type = 1;
            this.verifyLoading = true;
            this.showInputErrorEnterCode = false;
            if (!this.data.gameball && !this.data.profilePhone) {
                this.checkoutService
                    .checkPromo(this.data)
                    .subscribe((response: any) => {
                        this.verifyLoading = false;
                        if (response.code === 200 || response.code === 201) {
                            this.dialogRef.close(response);
                            this.embryoService.sendFlagToAddPromocodeButton(
                                false
                            );
                        } else if (response.code === 415) {
                            this.dialogRef.close(response);
                            this.embryoService.sendFlagToAddPromocodeButton(
                                false
                            );
                            this.snackBar.open(response.message, "×", {
                                panelClass: "error",
                                verticalPosition: "top",
                                duration: 3000,
                            });
                        } else {
                            // response.code == 409 here
                            if (response.code == 424) {
                                this.dialogRef.close(response);
                                this.embryoService.sendFlagToAddPromocodeButton(
                                    false
                                );
                            }
                            this.snackBar.open(response.message, "×", {
                                panelClass: "error",
                                verticalPosition: "top",
                                duration: 3000,
                            });
                        }
                    });
            } else {
                this.accountService.sendVerficationMessage(this.data).subscribe(
                    (response: any) => {
                        this.verifyLoading = false;
                        if (response.code === 200 || response.code === 201) {
                            this.dialogRef.close(response);
                            this.embryoService.sendFlagToAddPromocodeButton(
                                false
                            );
                            this.user.phone_verified = 1;
                            localStorage.setItem(
                                "auth_user_crocs",
                                JSON.stringify(this.user)
                            );
                            this.auth.userEmit.emit(this.user);
                        } else if (response.code === 415) {
                            this.dialogRef.close(response);
                            this.embryoService.sendFlagToAddPromocodeButton(
                                false
                            );
                            this.snackBar.open(response.message, "×", {
                                panelClass: "error",
                                verticalPosition: "top",
                                duration: 3000,
                            });
                        } else {
                            this.snackBar.open(response.message, "×", {
                                panelClass: "error",
                                verticalPosition: "top",
                                duration: 3000,
                            });
                        }
                    },
                    (err) => {
                        this.verifyLoading = false;
                    }
                );
            }
        } else {
            this.verifyLoading = false;
            this.showInputErrorEnterCode = true;

            this.verifyForm.get("code")?.markAsTouched();
        }
    }
    editPhone() {
        this.phoneSuccessflly = !this.phoneSuccessflly;
    }

    resendCode() {
        this.checkoutService.resendVerify().subscribe((response: any) => {
            if (response.code === 200) {
            } else {
                this.snackBar.open(response.message, "×", {
                    panelClass: "error",
                    verticalPosition: "top",
                    duration: 3000,
                });
            }
        });
    }

    submitCodeAndCreateOrder() {
        if (this.verifyForm.valid) {
            this.data.verification_code = this.verifyForm.get("code")?.value;
            this.data.device_type = 1;
            this.verifyLoading = true;
            this.showInputErrorEnterCode = false;
            // if (this.data.branch_id) {
            //     delete this.data.address_id;
            // }
            this.checkoutService
                .placeOrder(this.data)
                .subscribe((response: any) => {
                    this.verifyLoading = false;
                    if (response.code === 200 || response.code === 201) {
                        this.dialogRef.close(response);
                        this.embryoService.productCartSub.next([]);
                        this.embryoService.getProductCart();

                        this.router
                            .navigate([
                                this.lang + "/checkout/final-receipt",
                                response.data.uuid
                                    ? response.data.uuid
                                    : response.data.id,
                            ])
                            .then(() => {});
                    } else if (response.code === 202) {
                        localStorage.setItem("pay_url", response.data.pay_url);
                        // window.location.href = rep.data.pay_url;
                        const dialogRef = this.dialog.open(
                            IframeModalComponent,
                            {
                                width: "500px",
                                data: response.data.pay_url,
                            }
                        );
                    } else if (response.code == 203) {
                        localStorage.setItem("pay_url", response.data.pay_url);
                        window.open(response.data.pay_url, "_self");
                    } else if (response.code == 405) {
                        this.dialogRef.close(response);
                        const checkoutDialog = this.dialog.open(
                            CheckoutAcceptDialog,
                            {
                                width: "400px",
                                data: {
                                    device_type: 1,
                                    address_id: this.data.address_id,
                                    payment_method: this.data.payment_method,
                                    accept_payment_discount_dialog: false,
                                    notes: this.data.notes,
                                    verification_code: "",
                                    promo: this.data.promo,
                                    message: response.message,
                                },
                            }
                        );
                    } else if (response.code === 415) {
                        this.dialogRef.close(response);
                        this.snackBar.open(response.message, "×", {
                            panelClass: "error",
                            verticalPosition: "top",
                            duration: 3000,
                        });
                    } else {
                        this.snackBar.open(response.message, "×", {
                            panelClass: "error",
                            verticalPosition: "top",
                            duration: 3000,
                        });
                    }
                });
        } else {
            this.verifyForm.get("code")?.markAsTouched();
            this.showInputErrorEnterCode = true;
        }
    }

    close() {
        this.dialogRef.close();
    }
    formControlValidator(currentForm: any, controlName: any, err: any) {
        if (
            currentForm.controls[controlName].touched &&
            currentForm.controls[controlName].dirty
        ) {
            if (currentForm.controls[controlName].errors) {
                return currentForm.controls[controlName].errors[err];
            }
        }
    }
    markFormGroupTouched(formGroup: FormGroup) {
        (<any>Object)
            .values(formGroup.controls)
            .forEach((control: FormGroup, ind: any) => {
                control.markAsTouched();
                control.markAsDirty();
                if (control.controls) {
                    this.markFormGroupTouched(control);
                }
            });
    }
    numberOnly(event: any) {
        return (
            event.charCode >= 48 && event.charCode <= 57 && event.charCode != 32
        );
    }
}
